import { Key, ReactNode } from 'react';

import { MenuProps } from 'antd';

type MenuItem = Required<MenuProps>['items'][number];

export const getItem = (
  label: ReactNode,
  key: Key,
  icon?: ReactNode,
  children?: Array<MenuItem>
): MenuItem => ({
  key,
  icon,
  children,
  label,
});
